// extracted by mini-css-extract-plugin
export var statItem = "_ht-1";
export var statsRow = "_ht-0";